var React = require('react');

function LoupeLeftSide (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","fillRule":"evenodd","d":"M13 7A6 6 0 111 7a6 6 0 0112 0zm-1.41 5.286a7 7 0 11.696-.696.505.505 0 01.068.056l3.5 3.5a.5.5 0 01-.708.708l-3.5-3.5a.505.505 0 01-.057-.068z","clipRule":"evenodd"}));
}

LoupeLeftSide.defaultProps = {"fill":"currentColor","viewBox":"0 0 16 16"};

module.exports = LoupeLeftSide;

LoupeLeftSide.default = LoupeLeftSide;
